import clsx from "clsx";
import copy from "copy-to-clipboard";
import { useToasts } from "react-toast-notifications";

import { GenericTooltip } from "@components/tooltip-container";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";

export const UrlDataFormatter = ({
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { addToast } = useToasts();

  return (
    <div className="flex items-center mx-3 h-full font-sans relative name-table-cell">
      <div className="hide-cell-actions absolute h-full right-0">
        <div className="h-full flex items-center space-x-2">
          <GenericTooltip
            content="Copy"
            noInfoCircle
            overlayClassName="pointer-events-none"
          >
            <i
              className={clsx(
                "bg-white elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-clone",
                "cursor-pointer text-md text-primary font-light",
              )}
              onClick={() => {
                addToast("COPIED NAME TO CLIPBOARD", { appearance: "success" });
                copy(row.landingPage);
              }}
            ></i>
          </GenericTooltip>
        </div>
      </div>
      <div className="flex items-start flex-column w-full truncate">
        <GenericTooltip
          noInfoCircle
          content={row.landingPage}
          className="truncate w-full"
          overlayClassName="pointer-events-none  max-w-[800px] break-words"
          placement="top"
          mouseEnterDelay={1000}
        >
          <span className="font-semibold text-xs text-left text-cosmic w-full truncate">
            {row.landingPage}
          </span>
        </GenericTooltip>
      </div>
    </div>
  );
};
